/* eslint-disable */
import { createApp } from 'vue'
import App from './App.vue'

var queryObject;
try {
	queryObject = JSON.parse('{"' + decodeURI(location.search.substring(1)).replace(/"/g, '\\"').replace(/&/g, '","').replace(/=/g,'":"') + '"}');	
} catch(e){
	//no query obj set in request
	queryObject = {};
}
createApp(App).mount('#app')